import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import notifierReducer from './notifierReducer';
import usersReducer from '../views/Management/reducers/UsersReducer';
import operatorsReducer from '../views/Management/reducers/OperatorsReducer';
import settingsReducer from '../views/Management/reducers/SettingsReducer';
import dashboardInspectReducer from '../views/Dashboard/reducers/DashboardInspectReducer';
import mapReducer from '../components/Map/reducers/MapReducer';
import shutdown3gReducer from '../views/Shutdown3g/reducers/Shutdown3gReducer';
import oldOutagesReducer from '../views/OldOutagesMod/reducers/oldOutagesReducer';
import backOnAirReducer from '../views/BackOnAirMod/reducers/backOnAirReducer';
import tefInternalReducer from 'views/TefInternalMod/reducers/tefInternalReducer';
import emailsWrongRightReducer from '../views/EmailsWrongRight/reducers/emailsWrongRightReducer';
import incidentReducer from '../views/TelecomKPIAnomalyDetection/reducers/incidentReducer';
import kpiRuleReducer  from '../views/TelecomKPIAnomalyDetection/reducers/kpiRuleReducer';
import helixCrqsReducer from '../views/HelixCrqsMod/reducers/helixCrqsReducer';
import lookupReducer from '../views/TelecomKPIAnomalyDetection/reducers/lookupReducer';
import siteReducer from '../views/TelecomKPIAnomalyDetection/reducers/siteReducer';
import naspTrackerReducer from '../views/NaspTracker/reducers/naspTrackerReducer';
import dataIntegrityReducer from '../views/DataIntegrity/reducers/dataIntegrityReducer';

const rootReducer = combineReducers({
	session: sessionReducer,
	usersReducer,
	notifierReducer,
	operatorsReducer,
	settingsReducer,
	dashboardInspectReducer,
	mapReducer,
	shutdown3gReducer,
	emailsWrongRightReducer,
	tefInternalReducer,
	oldOutagesReducer,
	backOnAirReducer,
	incidents: incidentReducer,
	kpiRules:  kpiRuleReducer,
	lookups: lookupReducer,
	helixCrqsReducer,
	sites: siteReducer,
	naspTrackerReducer,
	dataIntegrity: dataIntegrityReducer
});

export default rootReducer;